import config from "./config";

function http(url, method, data = {}, stringify = true) {
  let headers = { Accept: "application/json" };
  const userData = JSON.parse(localStorage.getItem("inscrito-sos-aprova-2023"));

  if (userData) {
    data = {
      ...data,
      user: userData,
    };
  }

  if (method === "get" || method === "GET") {
    data = undefined;
  }

  if (stringify) {
    headers = { ...headers, "Content-Type": "application/json" };
  }
  return fetch(`${config.apiUrl}/${url}`, {
    method: method,
    headers,
    body: stringify ? JSON.stringify(data) : data,
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      return response;
    })
    .catch((err) => {
      return { error: err };
    });
}

export { http };
